import React from "react"
import {Link} from "react-router-dom"
import {checkAllowed, contextMenuItem} from "../functions"
import {MenuItem} from "./MenuItem"
import noteImg from "../images/note-4.png"
import img_context_menu from "../images/context-menu.png"

export class NoteElement extends React.Component {

    render() {

        let {k, auth, l, owner, item, documents} = this.props

        const note = item
        const menuItemData = {
            key: k,
            item: 'note',
            id: note["_id"],
            parent: note.parentFolder,
            from: 'view',
            link: `/${l}/note/open/${note["_id"]}`,
            accessLink: item.accessLink,
            name: item.name,
            thumb: noteImg
        }

        let href = menuItemData.link, target = ''
        if (documents.opening === 'open-public' || documents.opening === 'open-share') {
            href = item.accessLink
        }

        return (
            <div>
                <div className={"d-flex justify-content-center position-relative"}>
                    <Link to={`/${l}/note/open/${note["_id"]}`}
                          onContextMenu={(e) => {
                              if (checkAllowed(auth, documents.owner)) {
                                  contextMenuItem(e, k)
                              }
                          }}
                          onClick={() => {
                              if (documents.opening === 'open-public' && menuItemData.accessLink) {
                                  window.location.replace(href)
                              }
                          }}
                          target={target}>
                        <img id={"img-note"} src={noteImg}
                             className={"w-100 img-note rounded-4"}
                             alt={"..."}/>
                    </Link>
                    <div className={'hand-click'}
                         onClick={(e) => {
                             if (checkAllowed(auth, documents.owner)) {
                                 contextMenuItem(e, k)
                             }
                         }}>
                        {(!item.isShare || owner === 'trial-user') &&
                        <img id={"img-context-menu"} src={img_context_menu}
                             className={"w-100 rounded-2"}
                             alt={"..."}/>}
                    </div>
                    {<MenuItem data={menuItemData}/>}
                </div>
                <p id={"name-note"}
                   className={"name-note text-center mb-2 text-black p-0 fw-bold"}>{note.name}
                </p>
            </div>
        )
    }
}